export default __webpack_public_path__ + "static/media/pic7.18fb0a0f.jpg";